import { RequestLineModel } from './request-line.model';

export class RequestHeaderModel {
  id: number;
  hotel_id: number;
  profile_id: number;
  profile_name: string;
  profile_picture: string;
  email: string;
  phone_no: string;
  locale: string;
  room_no: string;
  note: string;
  type: string;
  reservation_type: string;
  start_date: Date;
  payment_type: 'Cash' | 'Debit' | 'Card' | 'Online';
  end_date: Date;
  room_count: number;
  approval_status: string;
  menu_section_id: number;
  menu_section_name: string;
  menu_category_id: number;
  menu_category_name: string;
  menu_item_id: number;
  menu_item_name: string;
  point: number;
  order_date: Date;
  status: string;
  staff_note: string;
  read: boolean;
  read_at: Date;
  read_by_user: string;
  in_the_process: boolean;
  in_the_process_at: Date;
  in_the_process_by_user: string;
  managed: boolean;
  managed_at: Date;
  managed_by_user: string;
  rejected: boolean;
  rejected_at: Date;
  rejected_by_user: string;
  created_at: Date;
  place_code: string;
  requestlines: RequestLineModel[];
  hotel_name: string;
  message_badge: number;
  profile_visit_status: string;
  line_type: string;
  updated_at: Date;
  is_gift: boolean;
  gift_to_profile_id: number;
  gift_to_name: string;
  gift_to_phone: string;
  gift_to_email: string;
  delivery_method: string;
  gift_to_address: string;
  gift_to_zip_code: string;
  gift_to_city: string;
  gift_to_country: string;
  product_type: string;
  voucher_no: string;
  display_name: string;
  callback_survey_rating: number;  // Görev kapandıktan sonra memnuniyet puanı
  callback_note: string;



  constructor() {

    this.id = 0;
    this.hotel_id = 0;
    this.profile_id = 0;
    this.profile_name = '';
    this.profile_picture = '';
    this.email = '';
    this.phone_no = '';
    this.locale = '';
    this.room_no = '';
    this.note = '';
    this.type = '';
    this.reservation_type = '';
    this.start_date = new Date(0);
    this.end_date = new Date(0);
    this.room_count = 0;
    this.approval_status = '';
    this.menu_section_id = 0;
    this.menu_section_name = '';
    this.menu_category_id = 0;
    this.menu_category_name = '';
    this.menu_item_id = 0;
    this.menu_item_name = '';
    this.point = 0;
    this.order_date = new Date();
    this.status = 'New';
    this.staff_note = '';
    this.read = false;
    this.read_at = new Date(0);
    this.read_by_user = '';
    this.in_the_process = false;
    this.in_the_process_by_user = '';
    this.in_the_process_at = new Date(0);
    this.managed = false;
    this.managed_at = new Date(0);
    this.managed_by_user = '';
    this.created_at = new Date();
    this.place_code = '';
    this.requestlines = [];
    this.hotel_name = '';
    this.message_badge = 0;
    this.profile_visit_status = '';
    this.is_gift = false;
    this.gift_to_profile_id = 0;
    this.gift_to_name = '';
    this.gift_to_phone = '';
    this.gift_to_email = '';
    this.delivery_method = '';
    this.gift_to_address = '';
    this.gift_to_zip_code = '';
    this.gift_to_city = '';
    this.gift_to_country = '';
    this.product_type = "Guestny";
    this.voucher_no = '';
    this.callback_survey_rating = 0;
    this.callback_note = '';

  }
}
